import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { problemCards } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ProblemSection() {
  return <section className="bg-mp-black py-20 md:py-28" data-id="element-287" data-mp="2vpzekzzlclkk">
      <Container data-id="element-288" data-mp="2voeg4za5oihf">
        <div className="max-w-[700px]" data-id="element-289" data-mp="39hw0gmao1z8i">
          <SectionTag tone="white" data-id="element-290" data-mp="39gupehtnhcqs">¿Te suena?</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-291" data-mp="35gaqb8pinz20">
            Ser monitor de pádel no debería significar inventarte 5 clases diferentes cada tarde.
          </h2>
        </div>

        <div className="mt-8 max-w-[650px] space-y-4 text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-292" data-mp="3ei0fe7vxelwm">
          <p data-id="element-293" data-mp="1p2u3901gs7lx">Tienes un grupo de iniciación a las 17:00.</p>
          <p data-id="element-294" data-mp="1k37p8odtanc2">Otro de nivel medio a las 18:00.</p>
          <p data-id="element-295" data-mp="1k4itepb65x3p">A las 19:00 aparecen cuatro alumnos con niveles completamente distintos.</p>
          <p data-id="element-296" data-mp="jeeomg1zv5eu">
            Y cuando llega el último grupo del día, tu cabeza ya ha preparado más bandejas que tu cesta de bolas.
          </p>
          <p data-id="element-297" data-mp="o9u57frdzfey">Entonces empiezas a tirar de lo conocido.</p>
          <p data-id="element-298" data-mp="sd076b7gukfm">Otra vez el mismo carro. Otra vez voleas. Otra vez bandejas.</p>
          <p data-id="element-299" data-mp="x4rwyjissm4p">Otra vez un partido al final para completar la hora.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} className="mx-auto mt-16 max-w-[750px] py-8 text-center md:mt-20 md:py-10" data-id="element-300" data-mp="123v181qyeobm">
          <p className="font-heading text-2xl uppercase leading-snug text-mp-white sm:text-3xl md:text-4xl" data-id="element-301" data-mp="1g3nqrtqquyi0">
            El problema no eres tú.
            <br data-id="element-302" data-mp="3duyu09mz8cys" />
            El problema es que nadie te dio un sistema.
            <br data-id="element-303" data-mp="3hvip77nzp6ia" />
            Hasta ahora.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} className="my-16 border-y border-mp-border py-12 text-center md:my-20 md:py-16" data-id="element-304" data-mp="ozh4wf1cv8nq">
          <p className="font-heading text-2xl uppercase leading-snug text-mp-white sm:text-3xl md:text-4xl" data-id="element-305" data-mp="tykaq1p5tiwr">
            El problema no es que no sepas de pádel.
          </p>
          <p className="mx-auto mt-4 max-w-[650px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-306" data-mp="130ju30nncz2v">
            El problema es no tener un sistema que convierta lo que sabes en clases organizadas, progresivas y
            fáciles de ejecutar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-307" data-mp="1qpcsr4vnll16">
          {problemCards.map((card, i) => <motion.div key={card.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i % 3 * 0.05
        }} className="rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-308" data-mp="1lrb0btcc89d1" data-mpi={i}>
              <p className="font-heading text-base uppercase tracking-wide text-mp-lime" data-id="element-309" data-mp="20cyn7m9xdrzl">{card.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-310" data-mp="1mlblh6x7rr9f">{card.copy}</p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}